// extracted by mini-css-extract-plugin
export default {"fs9":"Allorders_fs9__jmBIu","mb6":"Allorders_mb6__+rQ5-"};